import React from 'react';

import styled from 'styled-components';

import { Button } from '../Button';
import { Icon } from '../Icon';

const StyledPedagogyWithinStileCard = styled.div`
  grid-column: 1 / span 12;
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  gap: 48px;

  margin-bottom: 0;
  margin-top: 0;

  &:first-child {
    margin-top: 0;
    @media (max-width: 768px) {
      margin-top: 40px;
    }
  }

  @media (max-width: 768px) {
    margin-top: 40px;
    gap: 20px;
  }

  .--content {
    grid-column: 1 / span 4;
    @media (max-width: 768px) {
      grid-column: 1 / span 12;
      grid-row: 1;
      margin-bottom: 0;
    }

    @media (max-width: 1100px) {
      margin-bottom: 32px;
    }

    align-content: center;

    h4 {
      margin: 0 0 32px 0;
      @media (max-width: 768px) {
        margin-bottom: 20px;
      }
    }
  }

  .--image {
    grid-column: 5 / span 8;

    @media (max-width: 768px) {
      grid-column: 1 / span 12;
      grid-row: 2;
    }

    border: none;
    background: none;
    padding: 0;

    .gatsby-image-wrapper {
      @media (max-width: 768px) {
        border-radius: 20px;
      }
    }
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 24px;
  margin-bottom: 12px;

  @media (max-width: 768px) {
    margin-top: 20px;
  }
`;

const Subtitle = styled.div`
  color: var(--stile-grey-6);
  font-size: 14px;
  margin: 0;
  line-height: 1.5;
`;

type PedagogyWithinStileCardProps = React.HTMLAttributes<HTMLDivElement> & {
  id: string;
  title: string;
  description: React.ReactNode;
  image: React.ReactNode;
  buttonText?: string;
  subtitle?: React.ReactNode;
  url?: string;
};

const PedagogyWithinStileCard = function ({
  id,
  title,
  description,
  image,
  buttonText = 'View in lesson',
  subtitle,
  url,
  ...props
}: PedagogyWithinStileCardProps) {
  return (
    <StyledPedagogyWithinStileCard id={id} className={`--pedagogy-within-stile-card`} {...props}>
      <div className="--content">
        <h4>{title}</h4>
        <div>{description}</div>

        {((buttonText && url) || subtitle) && (
          <>
            {buttonText && url && (
              <ButtonContainer>
                <Button
                  style="secondary"
                  href={url}
                  newTab={true}
                  label={
                    <div>
                      <Icon
                        iconId="natural-user-interface"
                        iconSize="fontSize"
                        style={{ marginRight: 10 }}
                      />
                      {buttonText}
                    </div>
                  }
                />
              </ButtonContainer>
            )}
            {subtitle && <Subtitle>{subtitle}</Subtitle>}
          </>
        )}
      </div>
      <div className="--image">{image}</div>
    </StyledPedagogyWithinStileCard>
  );
};

export default PedagogyWithinStileCard;
